<template>
  <div>
    <!-- 入口挂件 -->
    <div
      class="plv-iar-rush-answer__entrance"
      v-if="entranceVisible"
      @click="clickEntrance"
    >
      <div class="plv-iar__rotate-circle__circle"></div>
      <div class="plv-iar__rotate-circle__text plv-font-din-pro-regular">{{ overTime }}</div>
    </div>
    <modal
      :width="320"
      :height="366"
      append-to-body
      v-if="visible"
    >
      <div class="plv-iar-rush-answer">
        <div class="plv-iar-rush-answer__head">
          <h1 class="plv-iar-rush-answer__head__title">{{ iarTrans('rushAnswer.rushAnswer') }}</h1>
          <span class="plv-iar-rush-answer__head__close-btn" @click="close">&times;</span>
        </div>
        <div v-if="inRushAnswer" class="plv-iar-rush-answer__start">
          <div class="plv-iar-rush-answer__start__main">
            <div class="plv-iar-rush-answer__countdown__text">{{ iarTrans('rushAnswer.countdown') }}</div>
            <div class="plv-iar-rush-answer__countdown__time">
              <div class="plv-iar__rotate-circle__circle"></div>
              <div class="plv-iar__rotate-circle__text plv-font-din-pro-regular">{{ overTime }}</div>
            </div>
          </div>
          <div class="plv-iar-rush-answer__remaining__text">{{ iarTrans('rushAnswer.remainingNumebr') }}：<span class="plv-iar-rush-answer__remaining__number">{{ remainingNumber }}</span>{{ iarTrans('rushAnswer.unit') }}</div>
        </div>
        <div
          v-else
          :class="[
            'plv-iar-rush-answer__end',
            `plv-iar-rush-answer__answer--${answerStatus ? 'success' : 'fail'}`
          ]"
        >
          <div class="plv-iar-rush-answer__status__icon"></div>
          <div v-if="answerStatus">
            <p class="plv-iar-rush-answer__end__text">{{ iarTrans('rushAnswer.success') }}</p>
            <p class="plv-iar-rush-answer__end__tip">{{ iarTrans('rushAnswer.waitForInvitation') }}</p>
          </div>
          <div v-else>
            <p class="plv-iar-rush-answer__end__text">{{ iarTrans('rushAnswer.fail') }}</p>
          </div>
        </div>
        <div class="plv-iar-rush-answer__footer">
          <button v-if="inRushAnswer" class="plv-iar-rush-answer__btn" @click="submit">{{ iarTrans('rushAnswer.answer') }}</button>
          <button v-else class="plv-iar-rush-answer__btn" @click="close">{{ iarTrans('rushAnswer.ok') }}</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/common/modal/PcModal.vue';
import mixin from './mixin';

export default {
  components: {
    Modal,
  },
  mixins: [mixin],
};
</script>

<style lang="scss">
@import './rush-answer.scss';

.plv-iar-rush-answer {
  border-radius: 4px;
}
.plv-iar-rush-answer__head {
  position: relative;
  padding-bottom: 16px;
}
.plv-iar-rush-answer__head__title {
  color: #333A47;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  margin: 0;
  padding-top: 24px;
  padding-left: 22px;
}
.plv-iar-rush-answer__head__close-btn {
  position: absolute;
  top: 27px;
  right: 24px;
  color: #545C6B;
  font-size: 26px;
  line-height: 16px;
  cursor: pointer;
}
.plv-iar-rush-answer__countdown__time {
  margin: 0 auto;
}
.plv-iar-rush-answer__remaining__number {
  margin-left: 0;
}
.plv-iar-rush-answer__footer {
  bottom: 24px;
}
.plv-iar-rush-answer__btn {
  background-color: #3082FE;
  padding: 5px 16px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    opacity: .8;
  }
}
.plv-iar-rush-answer__end {
  padding-top: 35px;
  &+.plv-iar-rush-answer__footer {
    bottom: 34px;
  }
}
</style>
